import lodash from 'lodash';
import AI_FIELDS from './resources/fields';

function buildFields(formPrefixId) {
	const fields = lodash.cloneDeep(AI_FIELDS);
	fields.map((field) => {
		field.id += formPrefixId;
		field.key = `${field.key}_${field.id}`;
		return field;
	});
	return fields;
}

export {
	buildFields,
};



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/buildFields.js